import styled from "styled-components";
import theme from "theme";

export const ForgotPasswordLink = styled.a`
    color: ${theme.colors.purple.primary};
    align-self: flex-end;
    font-weight: 600;
    text-decoration: none;
    font-size: 10px;

    &:visited {
        color: ${theme.colors.purple.primary};
    }

    &:hover {
        text-decoration: underline;
    }
`;
